import React, { useContext, useEffect, useState } from "react";
import { Heading, RichTextEditor } from "../../../components";
import Input from "../../../components/Input/Input";
import { ResumeContext } from "../../../contexts/resumeContext";
import { deleteIcon, Plus } from "../../../components/Icons/Icons";
import styles from "./ActivityForm.module.css";

function ActivityForm() {
  const newActivityBlock = {
    title: "",
    institution: "",
    startDate: "",
    endDate: "",
    location: "",
    description: "",
  };

  const { updateResumeInfo, resumeInfo } = useContext(ResumeContext);
  const [activityDetails, setActivityDetails] = useState(
    Object.values(
      resumeInfo?.misc?.activities || { 0: { ...newActivityBlock } }
    ) || [{}]
  );

  useEffect(() => {
    const miscSection = { ...resumeInfo.misc };
    miscSection["activities"] = activityDetails;

    updateResumeInfo.current("misc", miscSection, resumeInfo);
  }, [activityDetails]);

  const handleChange = (e, ix) => {
    let activityDetailsArr = [...activityDetails];
    let activityDetailsObj = activityDetailsArr[ix];
    activityDetailsObj[e.target.name] = e.target.value;
    activityDetailsArr[ix] = activityDetailsObj;
    setActivityDetails(activityDetailsArr);
  };

  const addBlock = () => {
    let activityDetailsArr = [...activityDetails, newActivityBlock];
    setActivityDetails(activityDetailsArr);
  };

  const deleteBlock = (ix) => {
    const activityDetailsArr = [...activityDetails];
    activityDetailsArr.splice(ix, 1);
    setActivityDetails(activityDetailsArr);
  };

  return (
    <div>
      <Heading editable content="Extra-curricular Activities" section="ACT" />
      {activityDetails.map((ed, ix) => (
        <div className="block" key={ix}>
          <button className="delete-btn" onClick={() => deleteBlock(ix)}>
            <img src={deleteIcon} />
          </button>
          <div className="row">
            <div className="col">
              <Input
                label="Function Title"
                name="title"
                onChange={(e) => handleChange(e, ix)}
                value={ed.title}
              />
            </div>
            <div className="col">
              <Input
                label="Employer/Institution"
                name="institution"
                onChange={(e) => handleChange(e, ix)}
                value={ed.institution}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                type="month"
                label="Start Date"
                name="startDate"
                placeholder="MM/YYYY"
                onChange={(e) => handleChange(e, ix)}
                value={ed.startDate}
              />
            </div>
            <div className="col">
              <Input
                type="month"
                label="End Date"
                name="endDate"
                placeholder="MM/YYYY"
                onChange={(e) => handleChange(e, ix)}
                value={ed.endDate}
              />
              <label>
                <input type="checkbox"/>
                Present
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="Location"
                name="location"
                onChange={(e) => handleChange(e, ix)}
                value={ed.location}
              />
            </div>
          </div>
          <div className="row">
            <RichTextEditor
              value={ed.description}
              placeholder="Mention more about your position of responsibilites or your note-worthy achievements"
              onChange={(value) =>
                handleChange({ target: { name: "description", value } }, ix)
              }
            />
          </div>
        </div>
      ))}
      <button className="link" onClick={addBlock}>
        Add More Activity <Plus />{" "}
      </button>
    </div>
  );
}

export default ActivityForm;
